import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect, Link } from 'react-router-dom';
import {fieldsAnimationClass, fieldsAnimationDelay} from '../Constants/animations';
import VehicleComponent from './VehicleComponent';
import DriverSectionComponent from './DriverSectionComponent';
//import data from '../data/index.json';
//import PolicyHistoryComponent from './PolicyHistoryComponent';
//import ClaimHistory from './ClaimHistory';
//import PolicyHistory from './PolicyHistory';
import { populateCustomerActivity, removeVehicle, removeDriver } from './actions';
import {updateTitle} from '../SectionTitle/actions';
//import lodashFind from 'lodash/find';
//import CardWrapper from './CardWrapper';

const mapStateToProps = (state) => {
    return {
        quoteStart: state.quoteStart,
        reviewData: state.ReviewReducer.reviewData,
        state: state
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        populateCustomerActivity: (data) => dispatch(populateCustomerActivity(data)),
        removeVehicle: (data) => dispatch(removeVehicle(data)),
        removeDriver: (data) => dispatch(removeDriver(data)),
        updateTitle: (titleObject) => dispatch(updateTitle(titleObject))
    }
}

class ReviewContainer extends React.Component {
    constructor(props){
        super(props);
        this.getDriver = this.getDriver.bind(this);
    }
    componentDidMount() {
        
        window.scrollTo(0,0);
        if (this.props.quoteStart.underWriting !== undefined) {
            const {vehicles, subjects} = this.props.quoteStart.underWriting.underwriting.body.completeQuote;
        this.props.updateTitle({
            title: `<h1>We found ${subjects.length} ${subjects.length > 1? 'drivers': 'driver' } 
            and ${vehicles.length} ${vehicles.length > 1? 'vehicles':'vehicle'}.</h1>`,
            subTitle: `Keep the vehicles and drivers you want to cover
            <div><span class="estimateMonths">$${this.props.state.userConfirmation.estimate}</span> for 6 months</div>`,
            image: '<i class="fa fa-search" aria-hidden="true"></i>'
        });


            const { completeQuote } = this.props.quoteStart.underWriting.underwriting.body
            if(!this.props.reviewData){
                this.props.populateCustomerActivity(completeQuote);
            }
            this.getDriver = this.getDriver.bind(this);
            this.getVehicle = this.getVehicle.bind(this);
        }
    }

    getVehicle(id) {
        const { vehicles } = this.props.reviewData;
        const itemToRemove = vehicles.find(element=> element.sequence === id);
        const removeItem = vehicles.indexOf(itemToRemove);
        const newArray = vehicles.slice();
        newArray.splice(removeItem,1);
        this.props.removeVehicle(newArray);
    }

    reviewHistory() {
        console.log('review history');
    }

    getDriver(id) {
        const { subjects } = this.props.reviewData;
        const itemToRemove = subjects.find(element=> element.sequence === id);
        const removeItem = subjects.indexOf(itemToRemove);
        const newArray = subjects.slice();
        newArray.splice(removeItem,1);
        this.props.removeDriver(newArray);
    }


    render() {
        console.log(this.props.reviewData)
        if (this.props.quoteStart.underWriting !== undefined) {
            const { reviewData } = this.props;
            if (reviewData !== undefined) {
                return (
                    <div 
                        style={fieldsAnimationDelay}
                        className={fieldsAnimationClass}>
                        <h1>Keep the drivers and vehicles you want</h1>
                        <p>It's all up to you.</p>

                        <DriverSectionComponent
                            onDriverClick={this.getDriver}
                            data={reviewData.subjects} />

                        <VehicleComponent
                            onVehicleClick={this.getVehicle}
                            data={reviewData.vehicles} />
                            <div className="app-form-actions">
                            <Link
                                className="btn btn-primary" 
                                to="/driver/0">
                                Review Drivers & Vehicles
                            </Link>
                            </div>
                    </div>
                );
            }
            else {
                return (
                    null
                );
            }
        }

        else {
            return (
                <Redirect to="/" />
            )
        }

    }
}

const connectedContainer = connect(mapStateToProps, mapDispatchToProps)(ReviewContainer);

export default withRouter(connectedContainer);


// WEBPACK FOOTER //
// ./src/Review/ReviewContainer.js